module.exports = __webpack_public_path__ + "static/media/YF77_3.9d4c31a2.jpg";